import { useEffect } from "react"
import {useHistory} from 'react-router-dom';

const SendMailButton = ({id}) => {
    const history = useHistory();

    useEffect(() => {
        let classes = document.getElementById('ID' + id).classList;
        classes.add('collapse')
        classes.add('show')
    });

    const sendMail = async () => {
        let token = localStorage.getItem('MAIL_ADS_TOKEN')
        let headers = new Headers({'Authorization': `Bearer ${token}`})
        let response = await fetch(window['MAIL_ADS_API_URL'] + '/sendmail/' + id, {method: 'POST', headers: headers})

        if (response.status === 401) {
            history.push('/login');
            return;
        }
    }

    return (
        <button onClick={sendMail} type="button" className="btn btn-primary m-1" data-bs-toggle="collapse" data-bs-target={'#ID' + id}>Send</button>
    )
}

export default SendMailButton
